import React from 'react'

const Erase = ({ className }) => {
  return (
    <svg
      width={46}
      height={46}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={23} cy={23} r={23} fill="#B1B1B1" fillOpacity="0.22" />
      <path
        className="ac-s"
        d="M22.563 29H18.2136C17.9174 29 17.6365 28.8687 17.4465 28.6415L14.5903 25.2259C14.2567 24.8269 14.2846 24.2388 14.6545 23.8732L17.3056 21.2533M22.563 29L24.0038 27.6M22.563 29L31 29M17.3056 21.2533L22.91 15.7148C23.3075 15.322 23.9498 15.3311 24.3359 15.7351L29.3703 21.003C29.7497 21.3999 29.738 22.0285 29.3442 22.4111L24.0038 27.6M17.3056 21.2533L24.0038 27.6"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Erase
